import { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Expand } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { GALLERY } from "@/data";

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);
  const reduce = useReducedMotion();

  return (
    <section id="galerie" data-testid="gallery-section" className="border-y border-slate-200 bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <span className="inline-block rounded-full border border-teal-200/70 bg-teal-50/80 px-3 py-1 font-mono text-xs uppercase tracking-[0.25em] text-teal-800">
            Galerie
          </span>
          <h2 className="mt-4 font-serif text-3xl font-medium tracking-tight text-slate-900 sm:text-4xl">
            Sehen Sie den <em className="italic text-sky-700">Unterschied.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {GALLERY.map((g, i) => (
            <motion.button
              key={g.caption}
              data-testid={`gallery-item-${i}`}
              onClick={() => setLightbox(g)}
              initial={{ opacity: 0, y: reduce ? 0 : 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group relative overflow-hidden rounded-xl text-left"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={g.src}
                  alt={g.caption}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <div>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-sky-300">{g.tag}</span>
                  <p className="font-serif text-sm font-medium text-white">{g.caption}</p>
                </div>
                <Expand className="h-4 w-4 text-white/80" />
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <Dialog open={!!lightbox} onOpenChange={() => setLightbox(null)}>
        <DialogContent data-testid="gallery-lightbox" className="max-w-4xl border-none bg-transparent p-0 shadow-none">
          {lightbox && (
            <img src={lightbox.src} alt={lightbox.caption} className="w-full rounded-xl object-cover" />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
